import { withInstall } from '../../../utils/with-install'
import MapType from './MapType.vue'

export const ElAmapControlMapType = withInstall(MapType)
export default ElAmapControlMapType
